import axios from "axios";

const buscarCategoriaServicio = async () => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/productos/categorias`,
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

export{
    buscarCategoriaServicio
}